<template>
  <div>
    <!-- 基本信息 -->
    <div class="Minister-top information">
      <div class="Minister-top-top Ministerbackground">
        <div class="Minister-top-left Minister-top-color">变体设置</div>
        <div class="bianti_desc">
          （价格为全球商品价格，仅填写国内成本即可）
        </div>
      </div>
      <div class="information_content" v-if="isVariant">
        <div class="information_input" style="margin-bottom: 20px">
          <div class="information_Title">规格</div>
          <div class="input_el">
            <div
              class="variant-option-box"
              v-for="(variant, idx) in variantList"
              :key="variant.key">
              <i
                class="element-icons el-icon-close icon-close"
                @click="deleteVariant(variant, idx)"></i>

              <div class="item-box">
                <div class="label">规格{{ idx === 0 ? '一' : '二' }}</div>

                <div class="content" v-if="variant.isShowOption">
                  <el-select
                    class="w300"
                    v-model="variant.label"
                    value-key="id"
                    filterable
                    allow-create
                    default-first-option
                    placeholder="请选择"
                    @change="(e) => onChangeByGuige(e, variant)">
                    <el-option
                      v-for="item in variantGuigeListA"
                      :key="item.key"
                      :label="item.name"
                      :disabled="item.disabled"
                      :value="item"></el-option>
                  </el-select>
                </div>
                <div class="content" v-else>
                  <el-button @click="addVariant(variant)">
                    + 新增规格{{ idx === 0 ? '一' : '二' }}
                  </el-button>
                </div>
              </div>
              <div
                class="item-box"
                v-if="
                  variant.label &&
                  variant.label.children &&
                  variant.label.children.length > 1
                ">
                <div class="label"></div>
                <div class="content">
                  <el-radio-group v-model="variant.group">
                    <el-radio
                      v-for="gro in variant.label.children"
                      :key="gro.key"
                      :label="gro"
                      style="margin: 4px">
                      {{ gro.name }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="item-box" v-if="variant.isShowOption">
                <div class="label">选项</div>
                <div class="content">
                  <div
                    class="content-item"
                    v-for="(opt, idy) in variant.options"
                    :key="opt.key">
                    <div
                      style="width: 40px; text-align: center; cursor: pointer"
                      v-if="idx === 0">
                      <el-popover
                        trigger="hover"
                        placement="right"
                        v-if="opt.imgUrl"
                        :open-delay="600">
                        <img :src="opt.imgUrl" class="prduct_img" alt />
                        <div slot="reference">
                          <img
                            :src="opt.imgUrl"
                            style="width: 28px; height: 28px"
                            @click="onSelectImg(idy)" />
                        </div>
                      </el-popover>
                      <i
                        v-else
                        class="element-icons el-icon-picture-outline icon-picture-outline"
                        style="font-size: 20px"
                        @click="onSelectImg(idy)"></i>
                    </div>
                    <el-select
                      class="w300"
                      v-model="variant.options[idy]"
                      value-key="id"
                      filterable
                      allow-create
                      default-first-option
                      placeholder="请选择">
                      <el-option
                        v-for="vari in variant.group.children"
                        :key="vari.key"
                        :label="vari.name"
                        :value="vari"></el-option>
                    </el-select>
                    <i
                      class="element-icons el-icon-plus icon-plus"
                      @click="addOption(variant)"></i>
                    <i
                      v-if="variant.options.length > 1"
                      class="element-icons el-icon-delete icon-delete"
                      @click="deleteOption(variant.options, idy)"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="information_input" style="margin-bottom: 20px">
          <div class="information_Title">规格表</div>
          <div class="input_el input_span">
            <el-row type="flex" align="middle" style="margin-bottom: 20px">
              <div class="information_Title" style="flex-shrink: 0">
                商品价格
              </div>
              <div class="input_el">
                <el-input v-model="formData2.price" placeholder="商品价格">
                  <template slot="prepend">USD</template>
                </el-input>
              </div>
              <div class="information_Title" style="flex-shrink: 0">
                商品数量
              </div>
              <div class="input_el">
                <el-input
                  v-model="formData2.stock"
                  placeholder="商品数量"></el-input>
              </div>
              <div class="information_Title" style="flex-shrink: 0">
                规格货号
              </div>
              <div class="input_el">
                <el-input
                  v-model="formData2.sku"
                  placeholder="规格货号"></el-input>
              </div>
              <div style="margin-left: 20px">
                <el-button type="primary" @click="onTaoyong">
                  全部套用
                </el-button>
              </div>
            </el-row>
            <el-table
              :data="guigeTableData"
              :span-method="guigeSpanMethod"
              border
              style="width: 100%">
              <template v-if="guigeTableData[0] && guigeTableData[0].guige1">
                <el-table-column
                  prop="guige1Val.name"
                  :label="guigeTableData[0].guige1.name">
                  <template slot-scope="scope">
                    <div>{{ scope.row.guige1Val.name }}</div>
                    <img
                      v-if="scope.row.guige1Val.imgUrl"
                      :src="scope.row.guige1Val.imgUrl"
                      style="width: 100px; height: 100px"
                      alt />
                  </template>
                </el-table-column>
              </template>
              <template v-if="guigeTableData[0] && guigeTableData[0].guige2">
                <el-table-column
                  prop="guige2Val.name"
                  :label="guigeTableData[0].guige2.name"></el-table-column>
              </template>
              <el-table-column prop="date" label="商品价格">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.price"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="商品数量">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.stock"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="规格货号">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.sku"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="information_content" v-else>
        <div class="information_input" style="margin-bottom: 20px">
          <div class="information_Title">变体</div>
          <div class="input_el input_span">
            <el-button type="primary" @click="isVariant = true">
              添加变体
            </el-button>
          </div>
        </div>
        <div class="information_input" style="margin-bottom: 20px">
          <div class="information_Title">
            <span class="tips">*</span>
            价格
          </div>
          <div class="input_el input_span">
            <el-input style="width: 300px" v-model="formData.price">
              <template slot="prepend">USD</template>
            </el-input>
          </div>
        </div>
        <div class="information_input" style="margin-bottom: 20px">
          <div class="information_Title">
            <span class="tips">*</span>
            库存
          </div>
          <div class="input_el input_span">
            <el-input style="width: 300px" v-model="formData.stock"></el-input>
          </div>
        </div>
      </div>
    </div>

    <xuanze-img
      v-model="xuanzeShow"
      :img-list="xuanzeList"
      @confirm="onConfirmByXuanzeImg"></xuanze-img>
  </div>
</template>

<script>
import { Baseurl } from '@/api/api/api'
import { ajaxPost } from '../../../api/api/api'

import XuanzeImg from './xuanzeImg.vue'

export default {
  name: 'biantiComp',
  components: {
    XuanzeImg
  },
  props: {},
  data() {
    return {
      roleInfo: null,
      isVariant: false,
      variantList: [
        {
          key: this.geKeyByTimeStamp(),
          label: '',
          group: '',
          options: [this.getOptionsTemplate()],
          isShowOption: false
        }
      ],
      variantGuigeList: [],
      formData: {
        price: '',
        stock: ''
      },
      formData2: {
        price: '',
        stock: 50,
        sku: ''
      },
      editList: null,
      xuanzeShow: false,
      xuanzeList: []
    }
  },
  computed: {
    variantGuigeListA() {
      const selectIds = this.variantList.map((item) => {
        if (item.label) {
          if (item.label.id) {
            return item.label.id
          }
        }
      })
      const result = this.variantGuigeList.map((item) => {
        item.disabled = selectIds.includes(item.id)
        return item
      })

      return result
    },
    guigeTableData() {
      let result = []

      const guige1Opt = this.variantList[0] ? this.variantList[0].options : []
      const guige2Opt = this.variantList[1] ? this.variantList[1].options : []

      const list = [guige1Opt, guige2Opt].reduce((a, b) =>
        a
          .map((aItem, idx) =>
            b.map((bItem, idy) => {
              let guige1Val, guige2Val
              if (typeof aItem === 'string') {
                guige1Val = { name: aItem, id: '' }
              } else {
                guige1Val = aItem
              }
              if (typeof bItem === 'string') {
                guige2Val = { name: bItem, id: '' }
              } else {
                guige2Val = bItem
              }
              return {
                guige1Val,
                guige2Val,
                price: '',
                stock: '',
                sku: '',
                idx,
                idy
              }
            })
          )
          .reduce((a, b) => [...a, ...b])
      )
      list.forEach((item) => {
        const temporary = { ...item }
        if (this.variantList[0].isShowOption) {
          const label = this.variantList[0].label
          if (typeof label === 'string') {
            temporary.guige1 = {
              name: label,
              id: ''
            }
          } else {
            temporary.guige1 = label
          }
        }
        if (this.variantList[1].isShowOption) {
          const label = this.variantList[1].label
          if (typeof label === 'string') {
            temporary.guige2 = {
              name: label,
              id: ''
            }
          } else {
            temporary.guige2 = label
          }
        }
        if (this.editList && this.editList.guigeTableData) {
          const item = this.editList.guigeTableData.find(
            (a) =>
              a.tierIndexX === temporary.idx && a.tierIndexY === temporary.idy
          )
          if (item && !item.isEdit) {
            temporary.price = item.originalPrice
            temporary.stock = JSON.parse(item.sellerStock)[0].stock
            temporary.sku = item.globalModelSku
            item.isEdit = true
          }
        }
        result.push(temporary)
      })

      return result
    }
  },
  watch: {},
  created() {
    this.roleInfo = JSON.parse(localStorage.getItem('role'))
  },
  methods: {
    onChangeByGuige(e, variant) {
      if (e.children && e.children.length === 1) {
        variant.group = e.children[0]
      } else {
        variant.group = ''
      }
      variant.options = [this.getOptionsTemplate()]
    },
    // 获取一个当前时间戳 + 随机六位数的key
    geKeyByTimeStamp() {
      return new Date().getTime() + Math.floor(Math.random() * 1000000)
    },
    async fetchGuige(options) {
      try {
        if (!options.merchantId || !options.categoryId) {
          this.variantGuigeList = []
          return
        }
        const url = Baseurl + '/shopeeGlobalProduct/getVariations'
        const payload = {
          merchant_id: options.merchantId,
          category_id: options.categoryId
        }
        const res = await ajaxPost(url, payload)
        const { code, data } = res.data
        if (code === 200) {
          if (data && data.data && data.data.standardise_variation_list) {
            this.variantGuigeList = data.data.standardise_variation_list.map(
              (item) => {
                const temporary = {
                  key: this.geKeyByTimeStamp(),
                  name: item.variation_name,
                  id: item.variation_id
                }
                if (item.variation_group_list) {
                  temporary.children = item.variation_group_list.map((item) => {
                    return {
                      key: this.geKeyByTimeStamp(),
                      name: item.variation_group_name,
                      id: item.variation_group_id,
                      children: item.variation_option_list.map((item2) => {
                        return {
                          key: this.geKeyByTimeStamp(),
                          name: item2.variation_option_name,
                          id: item2.variation_option_id,
                          imgUrl: ''
                        }
                      })
                    }
                  })
                }
                return temporary
              }
            )
          }
          console.log('this.variantGuigeList :', this.variantGuigeList)
          this.handleVariantList()
        }
      } catch (error) {
        console.log(error)
      }
    },
    getOptionsTemplate() {
      return { name: '', id: '', imgUrl: '', key: this.geKeyByTimeStamp() }
    },
    addVariant(variant) {
      variant.isShowOption = true
      if (this.variantList.length === 1) {
        this.variantList.push({
          key: this.geKeyByTimeStamp(),
          label: '',
          group: '',
          options: [this.getOptionsTemplate()],
          isShowOption: false
        })
      }
    },
    deleteVariant(variant, idx) {
      if (variant.isShowOption) {
        if (idx === 0) {
          if (this.variantList[1].isShowOption) {
            this.variantList.splice(0, 1)
            this.variantList.push({
              key: this.geKeyByTimeStamp(),
              label: '',
              group: '',
              options: [this.getOptionsTemplate()],
              isShowOption: false
            })
          } else {
            this.variantList = [
              {
                key: this.geKeyByTimeStamp(),
                label: '',
                group: '',
                options: [this.getOptionsTemplate()],
                isShowOption: false
              }
            ]
          }
        } else if (idx === 1) {
          variant.label = ''
          variant.group = ''
          variant.options = [this.getOptionsTemplate()]
          variant.isShowOption = false
        }
      } else {
        if (this.variantList.length === 1 && idx === 0) {
          this.isVariant = false
        }
      }
    },
    addOption(item) {
      item.options.push(this.getOptionsTemplate())
    },
    deleteOption(item, idy) {
      item.splice(idy, 1)
    },
    // 选择图片
    onSelectImg(idx) {
      this.operateOptionIdx = idx
      this.xuanzeShow = true
    },
    onConfirmByXuanzeImg(img) {
      const optionItem = this.variantList[0].options[this.operateOptionIdx]
      if (typeof optionItem === 'string') {
        this.variantList[0].options[this.operateOptionIdx] = {
          name: optionItem,
          id: 0,
          imgUrl: img
        }
      } else {
        optionItem.imgUrl = img
      }
      this.operateOptionIdx = null
    },
    guigeSpanMethod({ rowIndex, columnIndex }) {
      // 形参 { row, column, rowIndex, columnIndex }
      const len2 = this.variantList[1].options.length
      // 只有第一列合并
      if (columnIndex === 0) {
        // 根据规格2的长度取余合并
        if (rowIndex % len2 === 0) {
          return {
            rowspan: len2,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    getFormData() {
      if (this.isVariant) {
        return {
          hasVariant: this.isVariant,
          variantList: this.variantList.filter((item) => item.isShowOption),
          guigeTableData: JSON.parse(JSON.stringify(this.guigeTableData))
        }
      } else {
        return {
          hasVariant: this.isVariant,
          variantList: [],
          guigeTableData: [],
          ...this.formData
        }
      }
    },
    setXuanzeList(list) {
      this.xuanzeList = list
    },
    setFormData(data) {
      this.editList = data
      this.isVariant = data.isVariant
      this.setXuanzeList(data.xuanzeList)
      this.formData.price = data.price || ''
      this.formData.stock = data.stock || ''

      this.formData2.sku = data.sku || ''
    },
    handleVariantList() {
      if (this.editList && this.editList.variantList) {
        this.variantList = this.editList.variantList.map((vart) => {
          const label = this.variantGuigeList.find(
            (a) => a.id === vart.variation_id
          )
          const group = label.children.find(
            (a) => a.id === vart.variation_group_id
          )

          return {
            key: this.geKeyByTimeStamp(),
            label: label,
            group: group,
            options: vart.variation_option_list.map((b) => {
              const temporary = group.children.find(
                (a) => a.id === b.variation_option_id
              )
              if (!temporary) {
                group.children.push({
                  id: 0,
                  name: b.variation_option_name
                })
              }
              return {
                key: this.geKeyByTimeStamp(),
                name: b.variation_option_name,
                id: b.variation_option_id,
                imgUrl:
                  b.image_id &&
                  `https://s-cf-tw.shopeesz.com/file/${b.image_id}`
              }
            }),
            isShowOption: true
          }
        })
      }
    },
    onTaoyong() {
      const { price, stock, sku } = this.formData2
      this.guigeTableData.forEach((item) => {
        if (price) {
          item.price = price
        }
        if (stock) {
          item.stock = stock
        }
        if (sku) {
          item.sku = `${sku}-${item.guige1Val.name}-${item.guige2Val.name}`
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../shopee.less';
.bianti_desc {
  line-height: 40px;
  font-size: 16px;
}
.variant-option-box {
  width: 80%;
  background: #f6f6f6;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  position: relative;

  .icon-close {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }

  .item-box {
    display: flex;

    & + .item-box {
      margin-top: 20px;
    }

    .label {
      flex-shrink: 0;
      width: 10%;
      margin-top: 6px;
      text-align: right;
    }
    .content {
      flex: 1;
      margin-left: 20px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .w300 {
        width: 300px;
      }

      .content-item {
        flex: 1;
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .icon-plus,
        .icon-delete {
          font-size: 20px;
          margin-left: 14px;
          cursor: pointer;
        }

        .prduct_img {
          width: 500px;
          height: 500px;
        }
      }
    }
  }
}
</style>
